import { useAppSelector } from 'store/useAppSelector';

import {
  selectAssociatedAccountsLoaded,
  selectGithubUserAccount,
  selectGoogleUserAccount,
  selectIsUserInitialized,
  selectIsUserInitializing,
  selectIsWeb3OAuth,
  selectUserAddress,
  selectUserAddressType,
  selectUserETHAddressesLoaded,
  selectUserEmail,
  selectUserNickname,
  selectWeb3UserAccount,
} from '../store/selectors';

export const useUser = () => {
  const address = useAppSelector(selectUserAddress);
  const addressType = useAppSelector(selectUserAddressType);
  const associatedAccountsLoaded = useAppSelector(
    selectAssociatedAccountsLoaded,
  );
  const email = useAppSelector(selectUserEmail);
  const githubAccount = useAppSelector(selectGithubUserAccount);
  const googleAccount = useAppSelector(selectGoogleUserAccount);
  const isUserInitialized = useAppSelector(selectIsUserInitialized);
  const isUserInitializing = useAppSelector(selectIsUserInitializing);
  const isWeb3OAuth = useAppSelector(selectIsWeb3OAuth);
  const nickname = useAppSelector(selectUserNickname);
  const userETHAddressesLoaded = useAppSelector(selectUserETHAddressesLoaded);
  const web3Account = useAppSelector(selectWeb3UserAccount);

  return {
    address,
    addressType,
    associatedAccountsLoaded,
    email,
    githubAccount,
    googleAccount,
    isUserInitialized,
    isUserInitializing,
    isWeb3OAuth,
    nickname,
    userETHAddressesLoaded,
    web3Account,
  };
};
